import Service from "../Service";
const resource = "technicalVisit/";

export default {
    // isAdmin: isAdmin,
    listEvent(DateBegin, DateEnd, requestID) {
        return Service.post(resource + "calendar", { filter: { DateBegin, DateEnd } }, {
            params: { requestID },
        });
    },
    SendMail(filter, requestID) {
        return Service.post(resource + "SendMail", filter, {
            params: {
                requestID: requestID
            },
        });
    },

};